<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>Detail Pengguna</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'users-edit', params: {id: users.id }})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-edit"
            class="mb-4 self-end"
            size="medium"
          >Edit User</vs-button>
          <table>
            <template slot="thead">
              <th style="width: 150px;"></th>
              <th style="width: 20px;"></th>
              <th></th>
            </template>
            <tbody>
              <tr>
                <td>Nama</td>
                <td>:</td>
                <td>{{users.name}}</td>
              </tr>
              <tr />
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{{users.address}}</td>
              </tr>
              <tr />
              <tr>
                <td>No. Telepon</td>
                <td>:</td>
                <td>{{users.phone}}</td>
              </tr>
              <tr />
              <tr>
                <td>Username</td>
                <td>:</td>
                <td>{{users.authentication.email}}</td>
              </tr>
              <tr />
              <tr>
                <td>Role</td>
                <td>:</td>
                <td>{{getRole(users.role)}}</td>
              </tr>
              <tr />
              <tr>
                <td>Avatar</td>
                <td>:</td>
                <td></td>
              </tr>
              <tr />
            </tbody>
          </table>
        </div>
      </vs-card>
    </div>

    <div class="vx-col w-full flex flex-col">
      <vs-card>
        <div slot="header">
          <h3>Dinas Terhubung</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'users-agencies'})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="mb-4 self-end"
            size="medium"
          >Tambah Dinas</vs-button>
          <vs-table :data="agencies">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Dinas</vs-th>
              <vs-th>Pilihan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.nama">{{ tr.name }}</vs-td>
                <vs-td>
                  <div class="vx-row flex-col w-1/4 md:w-1/4 lg:w-1/4">
                    <vs-button
                      type="border"
                      color="danger"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="deleteAgent(tr.id)"
                      :id="`btn-delete-agent-${tr.id}`"
                    >Hapus</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </div>

    <div class="vx-col w-full flex flex-col">
      <vs-card>
        <div slot="header">
          <h3>Layanan Tersedia</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'users-services'})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="mb-4 self-end"
            size="medium"
          >Tambah Layanan</vs-button>
          <vs-table :data="services">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Layanan</vs-th>
              <vs-th>Status Antrian</vs-th>
              <vs-th>Pilihan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.nama">{{ tr.name }} ({{tr.agency}})</vs-td>
                <vs-td :data="tr.is_available_queue">
                  <vs-chip v-if="tr.is_available_queue == 1" color="green">Antrian Aktif</vs-chip>
                  <vs-chip v-else color="warning">Antrian Tidak Aktif</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row flex-col w-1/4 md:w-1/4 lg:w-1/4">
                    <vs-button
                      type="border"
                      color="danger"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="deleteService(tr.id)"
                    >Hapus</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>

      <vs-button
        @click="$router.push({name: 'users'})"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-start"
        size="medium"
      >Kembali</vs-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      users: {
        name: "",
        address: "",
        phone: "",
        authentication: { email: "" },
        role: "",
        avatar: ""
      },
      agencies: [],
      services: []
    };
  },
  mounted() {
    this.fetchUserData();
  },
  methods: {
    fetchUserData() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/user/${this.$route.params.id}`)
        .then(r => {
          this.users = r.data.data.user;
          this.agencies = r.data.data.agencies;
          this.services = r.data.data.services;
        })
        .catch(e => {
          this.$vs.notify({
            title: "Error",
            text: e,
            color: "warning"
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getRole(id) {
      let role = this.userRoles.find(item => {
        return item.id == id;
      });
      if (role) return role.label;
    },
    deleteAgent(id) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Apakah anda yakin ingin menghapus agent ini ?",
        accept: () => {
          this.$vs.loading();
          this.$http
            .delete(`/app/secure/user/${this.$route.params.id}/agency/${id}`)
            .then(() => {
              this.$vs.notify({
                title: "Sukses",
                text: "Berhasil menghapus dinas yang tehubung dengan akun ini.",
                color: "success",
                position: "top-right"
              });
              this.fetchUserData();
            })
            .catch(e => {
              this.$vs.notify({
                title: "Error",
                text: e,
                color: "warning"
              });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        }
      });
    },
    deleteService(id) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Apakah anda yakin ingin menghapus layanan ini ?",
        accept: () => {
          this.$vs.loading();
          this.$http
            .delete(`/app/secure/user/${this.$route.params.id}/service/${id}`)
            .then(() => {
              this.$vs.notify({
                title: "Sukses",
                text:
                  "Berhasil menghapus layanan yang terhubung dengan akun ini.",
                color: "success",
                position: "top-right"
              });
              this.fetchUserData();
            })
            .catch(e => {
              this.$vs.notify({
                title: "Error",
                text: e,
                color: "warning"
              });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        }
      });
    }
  },
  computed: {
    ...mapGetters(["userRoles"])
  }
};
</script>>